import '@vfde-brix/unordered-horizontal-list/dist/styles.css';
import { createUnorderedHorizontalListComponent } from '@vfde-brix/unordered-horizontal-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-unordered-horizontal-list', createUnorderedHorizontalListComponent, NO_PATTERN_BUSINESS_LOGIC);
